export const TOKEN = 'token'

export const TIME_STAMP = 'timeStamp'

export const TOKEN_TIMEOUT_VALUE = 2 * 3600 * 1000

export const LANG = 'language'

export const MAIN_COLOR = 'mainColor'

export const DEFAULT_COLOR = '#409eff'

export const TAGS_VIEW = 'tagsView'
